<script>
  import { layoutMethods, kantoAdsMethods, kantoAdsComputed, exportMethods, erpFixMessages  } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment';
  import Swal from "sweetalert2";

  /**
   * Cancellation Request List component
   */
  export default {
    page: {
      title: "Cancellation Request"
    },
    components: {
      flatPickr
    },
    computed: {
      ...kantoAdsComputed,
      ...erpFixMessages
    },
    data() {
      return {
        title: "Cancellation Request",
        searchValue: {
            search: null,
            searchField:null,
            page: 1,
            rows: 10,
            type: null,
            status: null,
            dateRange:null,
            loading:false,
            sort: 'id',
            orderDesc: true,
        },
        searchOptions: [
          { text: 'Search All', value: null },
          // { text: 'Cancellation Request Number', value: 'tmcr.id' },
          { text: 'SSS Listing', value: 'tmcd.store_name' },
          { text: 'Cancellation Request #', value: 'tmcr.ref_no' },
        ],
        cancellationOptions: [
          { text: 'All', value: null },
          { text: "Pending", value: "pending" },
          { text: "Accepted", value: "accepted" },
          { text: "Denied", value: "denied" },
        ],
        rangeOption: {
          mode: "range",
        },
        fields: [
          {key: "id",label: "Cancellation Request Number",sortable: true},
          {key: "brandOwner",sortable: false},
          {key: "sssStore",label: "SSS Listing",sortable: true},
          {key: "cancelStatus",label: "Status",sortable: true},
          {key: "orderNumber",sortable: true},
          {key: "collateralType",sortable: true},
          {key: "attempt",sortable: false},
          {key: "cancellationType", label:"Type of Cancellation", sortable: false},
          {key: "checkpointMonth",sortable: true},
          {key: "contractDuration",label:"Contract Duration (Months)",sortable: true},
          {key: "contractAmount",sortable: true},
          {key: "contractMonthyAmount",sortable: true},
          {key: "releasedDuration",sortable: false},
          {key: "releasedAmount",sortable: true},
          {key: "sssReleasedAmount",label:"Released Amount to SSS" ,sortable: true},
          {key: "peddlrProfit" ,sortable: true},
          {key: "cancellationFee" ,sortable: true},
          {key: "refundAmount" ,sortable: true},
          {key: "effectiveDate" ,sortable: true},
          {key: "rentedDate", label:'Rented Date and Time' ,sortable: true},
          {key: "requestDate", label:'Cancellation Date Requested' ,sortable: true},
          {key: "remarks" ,sortable: false},
        ],
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90 ,100],
        sortBy: "value",
        sortDesc: false,
      };
    },
    methods: {
      ...layoutMethods,
      ...kantoAdsMethods,
      ...exportMethods,
      async search(status) {
        if(status == "reset"){
          this.searchValue.page = 1;
        }
        this.searchValue.loading = true;
        await this.auditCancellationRequestList(this.searchValue)
        .then(()=>{
          this.searchValue.loading = false;
        });
      },
      tableSorting(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        this.search('reset');
      },
      refresh(){
        // this.auditCollateralType()
        this.search();
      },
      isValidDate(date){
        return moment(date).isValid()
      },
      async onExport(){
          await this.search();
          if(this.cancellationTotal == 0)
          {
            Swal.fire("Failed!", this.exportNullPrompt, "warning");
            return;
          }
          let params = {...this.searchValue, email: JSON.parse(localStorage.getItem("userData")).email, module: 'kantoads_audit_cancellation'};
          console.log("params: ", params);
          
          this.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
    },
    async mounted(){
      this.changeTitle({title: 'Cancellation'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Kanto Ads', to: { name: 'Kanto Ads'} },
          { text: 'Cancellation', to: { name: 'Audit Cancellation'} }
        ]
      });
      this.auditCollateralType();
      this.search();
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ cancellationTotal }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a class="btn btn-secondary"
                                    @click="refresh"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    > &nbsp; Refresh</a
                                >
                            </div>
                        </div>

                        <div class="d-flex flex-row col-12">
                          <div class="me-3">
                            <form class="d-flex" @submit.prevent="search('reset')">
                              <b-form-group id="input-group-3" label-for="input-3">
                                <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                              </b-form-group>
                              <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                              </b-form-group>
                            </form>
                          </div>
                          <div class="me-3">
                            <b-form-group id="input-group-1" label-for="input-1">
                              <template v-slot:description><div class="d-flex justify-content-end">Filter By Collateral Type</div></template>
                              <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-1" v-model="searchValue.type" :options="collateralOptions"></b-form-select>
                            </b-form-group>
                          </div>
                          <div class="me-3">
                            <b-form-group id="input-group-2" label-for="input-2">
                              <template v-slot:description><div class="d-flex justify-content-end">Filter By Status</div></template>
                              <b-form-select class="form-select rounded-0 rounded-start shadow-none w-150px" id="input-2" v-model="searchValue.status" :options="cancellationOptions"></b-form-select>
                            </b-form-group>
                          </div>
                          <div class="me-3">
                            <b-form-group>
                              <template v-slot:description><div class="d-flex justify-content-end">Filter by Date Duration</div></template>
                              <flat-pickr
                                v-model="searchValue.dateRange"
                                :config="rangeOption"
                                placeholder="Select a date range"
                                class="form-control"
                                style="width: fit-content"
                              ></flat-pickr>
                            </b-form-group>
                          </div>
                          <div class="me-3">
                            <b-form-group label="">
                              <b-button variant="primary" type="button" @click="search('reset')" class="px-2 me-3">
                                <i class='bx bx-search bx-fw'></i>
                                Search
                              </b-button>
                              <b-button variant="primary" type="button" class="px-2" @click="onExport()">
                                <i class="uil uil-export me-1"></i>
                                Export
                              </b-button>
                            </b-form-group>
                          </div>
                        </div>
                        <!-- end col record display--> 
                    </div>
                    <!-- end row -->
                    <div class="table-responsive">
                      <div class="table align-middle table-nowrap">
                        <b-table
                          :items="cancellationList"
                          :fields="fields"
                          responsive="md"
                          class="table-check"
                          :current-page="searchValue.page"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          @sort-changed="tableSorting"
                        >
                          <template #cell(id)="data">
                            <p class="text-capitalize text-center">{{ data.item.refNo == null ? data.item.id : data.item.refNo}}</p>
                          </template>
                          <template #cell(brandOwner)="data">
                            <router-link :to="{ name: 'Audit Cancellation Form', params: { id : data.item.id }}" class="text-capitalize">
                              <i class="text-primary bx bx-pencil" v-if="data.item.cancelStatus == 'pending'"></i>
                              <i class="uil-eye" v-else></i>
                              {{ data.item.brandOwner}}
                            </router-link>
                          </template>
                          <template #cell(sssStore)="data">
                            <p class="text-capitalize text-center">{{ data.item.sssStore}}</p>
                          </template>
                          <template #cell(cancelStatus)="data">
                            <p class="text-capitalize text-center"
                            :class="{
                              'text-warning':data.item.cancelStatus == 'pending',
                              'text-danger':data.item.cancelStatus == 'denied',
                              'text-success':['accepted','approved'].includes(data.item.cancelStatus)
                              }">
                              {{ data.item.cancelStatus}}
                            </p>
                          </template>
                          <template #cell(collateralType)="data">
                            <p class="text-capitalize text-center">{{ data.item.collateralType}}</p>
                          </template>
                          <template #cell(attempt)="data">
                            <p class="text-capitalize text-center">{{ data.item.attempt}}</p>
                          </template>
                          <template #cell(checkpointMonth)="data">
                            <p class="text-capitalize text-center">{{ data.item.checkpointMonth}}</p>
                          </template>
                          <template #cell(contractDuration)="data">
                            <p class="text-capitalize text-center">{{ data.item.contractDuration}}</p>
                          </template>
                          <template #cell(contractAmount)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.contractAmount | toCurrency}}</p>
                          </template>
                          <template #cell(contractMonthyAmount)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.contractMonthyAmount | toCurrency}}</p>
                          </template>
                          <template #cell(releasedDuration)="data">
                            <p class="text-capitalize text-center">{{ data.item.releasedDuration}}</p>
                          </template>
                          <template #cell(releasedAmount)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.releasedAmount | toCurrency}}</p>
                          </template>
                          <template #cell(sssReleasedAmount)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.sssReleasedAmount | toCurrency}}</p>
                          </template>
                          <template #cell(peddlrProfit)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.peddlrProfit | toCurrency}}</p>
                          </template>
                          <template #cell(cancellationFee)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.cancellationFee | toCurrency}}</p>
                          </template>
                          <template #cell(refundAmount)="data">
                            <p class="text-capitalize text-end">PHP {{ data.item.refundAmount | toCurrency}}</p>
                          </template>
                          <template #cell(effectiveDate)="data">
                            <p v-if="isValidDate(data.item.effectiveDate)">
                              {{ data.item.effectiveDate | formatDateOnly}}
                            </p>
                            <p class="text-center" v-else>
                              --
                            </p>
                          </template>
                          <template #cell(rentedDate)="data">
                            {{ data.item.rentedDate | formatDateNoComma}}
                          </template>
                          <template #cell(requestDate)="data">
                            {{ data.item.requestDate | formatDateNoComma}}
                          </template>
                          <template #cell(remarks)="data">
                            <span v-bind:title='data.item.remarks'>
                              {{ data.item.remarks | truncator(20,'...')}}
                            </span>
                          </template>
                        </b-table>
                      </div>
                    </div>
                    <div class="row g-0 text-center" v-if="cancellationTotal == 0">
                      <span>No data to display.</span>
                    </div>
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col">
                          <div class="form-group row pull-left">
                            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                            <div class="col-sm-6">
                              <b-form-group label-for="display-record">
                                <b-form-select class="form-select shadow-none w-fit"
                                  id="display-record"
                                  v-model="searchValue.rows"
                                  :options="pageOptions"
                                  @change="search()"
                                ></b-form-select>
                              </b-form-group>
                            </div>
                          </div>
                          <div
                            class="
                              dataTables_paginate
                              paging_simple_numbers
                              float-end
                            "
                          >
                            <!-- pagination -->
                            <b-pagination
                              v-if="cancellationTotal != 0 && cancellationTotal > searchValue.rows"
                              class="pagination-rounded"
                              v-model="searchValue.page"
                              :total-rows="cancellationTotal"
                              @input="onPageUpdate()"
                              :per-page="searchValue.rows"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>

                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>